import { render, staticRenderFns } from "./CoursesPage.vue?vue&type=template&id=fd57e5bc&scoped=true"
import script from "./CoursesPage.vue?vue&type=script&lang=js"
export * from "./CoursesPage.vue?vue&type=script&lang=js"
import style0 from "./CoursesPage.vue?vue&type=style&index=0&id=fd57e5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd57e5bc",
  null
  
)

export default component.exports